module.exports = __webpack_public_path__ + "static/media/virtualteam.9c105049.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/virtualteam.png
// module id = 894
// module chunks = 0